import React from "react";
import { SidebarProvider } from "integrations/aws/context/Sidebar";
import FormDataProvider from "integrations/contexts/FormDataProvider";
import { StepsProvider } from "integrations/aws/context/Steps";
import { ApiProvider } from "integrations/aws/context/Api";
import { AdvancedOptionsProvider } from "integrations/aws/context/AdvancedOptions";
import { toGenericInputCreateRequest } from "integrations/aws/common/formDataAdapter";
import CloudWatch from "./CloudWatch";
import INITIAL_FORMDATA from "./_initialFormData";
const EmbeddedCloudWatchApp = ({ onSubmit = void 0 }) => {
  const handleSubmit = (formData) => {
    if (!onSubmit) {
      return;
    }
    onSubmit(toGenericInputCreateRequest(formData));
  };
  return /* @__PURE__ */ React.createElement(ApiProvider, null, /* @__PURE__ */ React.createElement(StepsProvider, null, /* @__PURE__ */ React.createElement(FormDataProvider, { initialFormData: INITIAL_FORMDATA }, /* @__PURE__ */ React.createElement(SidebarProvider, null, /* @__PURE__ */ React.createElement(AdvancedOptionsProvider, null, /* @__PURE__ */ React.createElement(CloudWatch, { onSubmit: handleSubmit, externalInputSubmit: typeof onSubmit === "function" }))))));
};
export default EmbeddedCloudWatchApp;
